<ng-template>
  <div (click)="closed.emit()" class="dropdown-content">
    <ng-content></ng-content>
  </div>
</ng-template>
